export default __webpack_public_path__ + "static/media/BatteryMaintenance4.eb978f40.png";